import React, { useLayoutEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Box, useResponsive } from '@common-fe/common-fe';

import routes from '@/common/routes';
import { Topbar } from '@/modules/core/components';
import { useMyMoneyNavigation } from '@/modules/UseMyMoney/hooks';
import { useResetUseMyMoney } from '@/modules/UseMyMoney/hooks';
import { ScrollbarGutterStyle } from '@/styles/ScrollbarGutterStyle.styles';
import theme from '@/styles/theme';

import ReadyToScanStepContainer from './widgets/ReadyToScanStep/ReadyToScanStep.container';
import SelectUseMyMoneyOptionStepContainer from './widgets/SelectUseMyMoneyOptionStep/SelectUseMyMoneyOptionStep.container';
import UseMyMoneySummaryContainer from './widgets/UseMyMoneySummary/UseMyMoneySummary.container';

const UseMyMoneyContainer = () => {
  const { isMobile } = useResponsive();
  const { navigateToSelectOption } = useMyMoneyNavigation();

  useLayoutEffect(() => {
    navigateToSelectOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useResetUseMyMoney();

  return (
    <Box
      data-testid="use-my-money_container"
      height={{ min: isMobile ? theme.controls.mobileHeightWithBackButton : '100vh' }}
    >
      <ScrollbarGutterStyle />

      {isMobile ? null : (
        <Box margin={{ left: 'max(32px, calc((100% - 824px) / 2))', right: '40px'}} >
          <Topbar   />
        </Box>
      )}

      <Box
        pad={{ bottom: 'spacing48', horizontal: isMobile ? 'spacing16' : 'spacing32' }}
        flex="grow"
        width={{ max: '888px', width: '100%' }}
        alignSelf="center"
      >
        <Switch>
          <Route
            key={routes.USE_MY_MONEY}
            path={routes.USE_MY_MONEY}
            exact
          >
            <SelectUseMyMoneyOptionStepContainer />
          </Route>
          <Route
            key={routes.USE_MY_MONEY_READY_TO_SCAN}
            path={routes.USE_MY_MONEY_READY_TO_SCAN}
            exact
          >
            <ReadyToScanStepContainer />
          </Route>
          <Route
            key={routes.USE_MY_MONEY_SUMMARY}
            path={routes.USE_MY_MONEY_SUMMARY}
          >
            <UseMyMoneySummaryContainer />
          </Route>
        </Switch>
      </Box>
    </Box>
  );
};

export default UseMyMoneyContainer;
